import { Component, ErrorHandler, OnInit, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/user.service';


@Component({
  selector: 'app-regis-payment-summary',
  templateUrl: './regis-payment-summary.component.html',
  styleUrls: ['./regis-payment-summary.component.css']
})
export class RegisPaymentSummaryComponent implements OnInit {
  data: any;
  payment: any= {};
  APP_REG_NO: any;
 

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
  }

  ngOnInit() {
    
  //  this.getRegpaymentsummary(this.APP_REG_NO);
    this.route.queryParams.subscribe(params => {
    const appNo = params['appNo'];

    if (appNo) {
      this.getRegpaymentsummary(appNo);
    }
  });
  }

  

   getRegpaymentsummary(APP_REG_NO) {
    debugger
  document.getElementById('loader-spinner').style.display = "block";

  this.data = this.userService.getregpaymentsummary(APP_REG_NO);
  this.data.subscribe(
    (response: any) => {
      this.payment = response;
      if(this.payment.Payment_Method === 'Challan'){
        this.payment.Online_Payment_Date = 'NA'
      }
       if(this.payment.Payment_Method === 'Online'){
        this.payment.Challan_Payment_Date = 'NA'
      }
      // this.router.navigate(['/page1']);
      document.getElementById('loader-spinner').style.display = "none";
    },
    (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.handleError(error);
    }
  );
}

printPage() {
  window.print();
}


}




// WEBPACK FOOTER //
// ./src/app/registration/regis-payment-summary/regis-payment-summary.component.ts